// extracted by mini-css-extract-plugin
export default {"quick":"QuickM_quick__YuOU9","q_q_menu":"QuickM_q_q_menu__vziiW"};